<template>
  <div class="grid-y flex-grow divide-y">
    <Loading v-if="waitPending" :loading="waitPending"/>
    <div
      class="flex-shrink-0 container-tabs padding-horizontal-2 flex flex-row justify-between"
      v-if="subject">
      <nav class="tabs">
        <ul>
          <li :class="$classnames({
          'active': subject.family === false,
          'opacity-50 pointer-events-none': subject.family === true,
        })">
            <span>Одиночное захоронение</span>
          </li>
          <li :class="$classnames({
          'active': subject.family === true,
          'opacity-50 pointer-events-none': subject.family === false,
        })">
            <span>Семейное захоронение</span>
          </li>
        </ul>
      </nav>
      <div class="flex flex-row items-center space-x-10">
      <span
        class="text-16px leading-18px text-primary font-bold cursor-pointer"
        @click="subject.family = true"
        v-if="subject.family === false">
        Сделать семейным
      </span>
      </div>
    </div>
    <div
      class="cell auto flex"
      v-if="subject">
      <div class="grid-x flex-grow">
        <div class="cell auto flex flex-grow cell-block-container">
          <template v-if="subject.family === false">
            <ObjectNewSingle
              :payload="subject"
              @save="($event) => save($event)"/>
          </template>
          <template v-if="subject.family === true">
            <ObjectNewFamily
              :payload="subject"
              @save="($event) => save($event)"/>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _, { cloneDeep } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import ObjectNewSingle from '@/pages/Objects/ObjectNew/ObjectNewSingle.vue';
import ObjectNewFamily from '@/pages/Objects/ObjectNew/ObjectNewFamily.vue';
import Loading from '@/components/Loading.vue';

export default {
  components: {
    ObjectNewSingle,
    ObjectNewFamily,
    Loading,
  },
  data() {
    return {
      subject: null,
      waitPending: false,
    };
  },
  computed: {
    ...mapState({
      countries: (state) => state.settings.countries,
    }),
    ...mapGetters({
      enumsGetter: 'settings/selectEnums',
      objectGetter: 'objects/object',
      regionsGetter: 'settings/regions',
      districtsGetter: 'settings/districts',
      cemeteriesGetter: 'settings/cemeteries',
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    object() {
      if (this.id) {
        return this.objectGetter(this.id);
      }
      return null;
    },
    enums() {
      return {
        sizes: this.enumsGetter('size'),
        fences: this.enumsGetter('fence'),
        headstone: this.enumsGetter('headstones'),
        pedestal: this.enumsGetter('pedestals'),
        flowerGarden: this.enumsGetter('flowerGardens'),
      };
    },
  },
  methods: {
    ...mapActions({
      fetch: 'objects/ACT_FETCH_OBJECT',
      fetchRegions: 'settings/ACT_FETCH_REGIONS',
      fetchDistricts: 'settings/ACT_FETCH_DISTRICTS',
      fetchCemeteries: 'settings/ACT_FETCH_CEMETERIES',
      update: 'objects/ACT_UPDATE_OBJECT',
    }),
    setPayload(data) {
      const cemetery = _.get(data, 'cemetery.id');
      const district = _.get(data, 'cemetery.district.id');
      const region = _.get(data, 'cemetery.district.region.id');
      const country = _.get(data, 'cemetery.district.region.country.id');
      this.subject = {
        family: data.family,
        name: data.name,
        photoAttach: data.photoAttach ? [data.photoAttach] : [],
        location: {
          country: _.find(this.countries, (obj) => obj.id === country) || null,
          region: _.find(this.regionsGetter(country), (obj) => obj.id === region) || null,
          district: _.find(this.districtsGetter(region), (obj) => obj.id === district) || null,
          cemetery: _.find(this.cemeteriesGetter(district), (obj) => obj.id === cemetery) || null,
          crypt: _.get(data, 'crypt') || '',
          section: _.get(data, 'section') || '',
          fence: _.find(this.enums.fences, (fence) => fence.value === data.fence) || null,
          size: _.find(this.enums.sizes, (size) => size.value === data.size) || null,
          location: data.location || {
            lat: '',
            lng: '',
          },
        },
        updateBurials: data.burials.map((burial) => ({
          ...burial,
          headstone: _.find(
            this.enums.headstones,
            (obj) => obj.value === burial.headstone,
          ) || null,
          flowerGarden: _.find(
            this.enums.flowerGardens,
            (obj) => obj.value === burial.flowerGarden,
          ) || null,
          pedestal: _.find(
            this.enums.pedestals,
            (obj) => obj.value === burial.pedestal,
          ) || null,
        })),
        about: {
          celebrity: data.celebrity,
          order: data.order,
        },
      };
    },
    save(query) {
      const data = cloneDeep(query);
      if (data?.createBurials?.length) {
        data.createBurials = data.createBurials.map((burial) => {
          const copy = cloneDeep(burial);
          copy.createPersons = copy.persons;
          delete copy.persons;
          return copy;
        });
      }
      if (data?.updateBurials?.length) {
        data.updateBurials = data.updateBurials.map((burial) => {
          const copy = cloneDeep(burial);
          const createPersons = [];
          const updatePersons = {};
          copy.persons.forEach((person) => {
            if (person.id) {
              updatePersons[person.id] = person;
            } else {
              createPersons.push(person);
            }
          });
          if (createPersons.length) {
            copy.createPersons = createPersons;
          }
          if (Object.keys(updatePersons).length) {
            copy.updatePersons = updatePersons;
          }
          delete copy.persons;
          return copy;
        });
      }
      this.update({
        id: this.id,
        payload: data,
      }).then(() => {
        this.$router.push({
          name: 'objects.details',
          params: {
            id: this.id,
          },
        });
      });
    },
  },
  watch: {
    $route: {
      handler() {
        this.waitPending = true;
        this.fetch(this.id).then((value) => {
          const district = _.get(value, 'cemetery.district.id');
          const region = _.get(value, 'cemetery.district.region.id');
          const country = _.get(value, 'cemetery.district.region.country.id');
          Promise.all([
            this.fetchRegions(country),
            this.fetchDistricts(region),
            this.fetchCemeteries(district),
          ]).then(() => {
            /** Для иммутабельности объект должен быть глубокой копией */
            this.setPayload(_.cloneDeep(value));
          }).finally(() => {
            this.waitPending = false;
          });
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
